const history = {
  historyHttpRequest: {
    endpoint: '/api/v1/classes/history',
    method: 'GET',
    requiresAuth: true,
    timezone: true
  }
}

export default history